"use client";

import type { BlockType } from "./types";
import { createEmptyRichText } from "./utils";
import { createTableDoc, TABLE_SCHEMA_VERSION } from "@/cms/blocks/table";

export const DEFAULT_BLOCK_DATA: Record<BlockType, () => any> = {
  heading: () => ({ level: 2, text: "" }),
  contact: () => ({}),
  paragraph: () => ({
    variant: "default",
    richText: createEmptyRichText(),
  }),
  image: () => ({ url: "", alt: "", variant: "default" }),
  divider: () => ({ variant: "space" as const }),
  list: () => ({ ordered: false, items: [] }),
  faq: () => ({ items: [] }),
  quote: () => ({ text: "", cite: "", variant: "default" as const }),
  link: () => ({ title: "", variant: "default" as const, mode: "url", url: "", contentSlug: "", contentId: "" }),
  embed: () => ({ url: "" }),
  contentReference: () => ({
    contentId: "",
    type: "",
    status: "",
    title_en: "",
    title_fa: "",
    slug_en: "",
    slug_fa: "",
  }),
  reference: () => ({
    referenceIds: [],
  }),
  productCard: () => ({ products: [] }),
  table: () => ({
    schemaVersion: TABLE_SCHEMA_VERSION,
    doc: createTableDoc(),
    variant: "default" as const,
  }),
};
